import { settings } from "./settings";
import { node } from "./hmcConfig";
import { log } from "./logger";

export const setPageVisibility = (page, i) => {
  settings.pageVisibleIf[i] = [];
  if (page[node.VISIBLEIF]) {
    const conditions = splitOrCondition(page[node.VISIBLEIF]);
    conditions.forEach((element) => {
      const test = splitPageCondition(element);
      if (test) {
        settings.pageVisibleIf[i].push({
          question: test[0],
          operator: test[2],
          values: test[1],
        });
      }
    });
  }
};

export const isNextPageVisible = (nextPage) => {
  if (settings.lastPage === nextPage) return true;
  return checkNextPageVisibility(nextPage);
};

const checkNextPageVisibility = (nextPage) => {
  const arr = settings.pageVisibleIf[nextPage];
  if (arr.length > 0) {
    let loopFound = false;
    arr.forEach((expression) => {
      const q = expression.question;
      let found = false;
      switch (expression.operator) {
        case "anyof":
          if (settings.answersMap[q].length > 0) {
            found = settings.answersMap[q].some((ai) =>
              expression.values.includes(ai)
            );
            if (found) loopFound = true;
          }
          break;
        case "=":
          if (
            settings.answersMap[q].length > 0 &&
            settings.answersMap[q].length == expression.values.length
          ) {
            found = settings.answersMap[q].every((ai) =>
              expression.values.includes(ai)
            );
            if (found) loopFound = true;
          }
          break;
        default:
          break;
      }
    });
    if (loopFound) return true;
    return false;
  }

  return true;
};
const splitOrCondition = (exp) => {
  return exp.split(" or ");
};

const splitPageCondition = (exp, delimiter = "anyof") => {
  var test = exp.match(/^{(.*)}\s(anyof|=)\s([\[|\'].*[\]|\'+])$/);
  log(test);
  if (test.length > 1) {
    var testSingleValue = test[3].match(/^'.*'$/);
    if (!!testSingleValue) {
      test[3] = "[" + test[3] + "]";
    }
    return [test[1], JSON.parse(test[3].replace(/'/g, '"')), test[2]];
  }
  return false;
};
